// extracted by mini-css-extract-plugin
module.exports = {"vertical_menu":"ApxView_vertical_menu__3Jbh2"};